import React from 'react'
import { Accordion, AccordionSummary, Typography, AccordionDetails } from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import './priceplan.scss'

const MarketplacePlanBenefits = () => {
    return (
        <div style={{ marginBottom: '30px' }}>
            <div style={{
                fontFamily: 'Inter Bold',
                fontSize: '28px',
                color: '#1B1642',
                marginBottom: '30px'
                // fontFamily: 'Segoe UI',
            }}>Explore Marketplace plan benefits in more detail</div>
            <Accordion>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1-content"
                    id="panel1-header"
                >
                    <Typography component="span">Accordion 1</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse
                    malesuada lacus ex, sit amet blandit leo lobortis eget.
                    <ul>
                        <li> syed haq</li>
                        <li> syed haq</li>
                    </ul>
                </AccordionDetails>
            </Accordion>
            <Accordion>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel2-content"
                    id="panel2-header"
                >
                    <Typography component="span">Accordion 2</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse
                    malesuada lacus ex, sit amet blandit leo lobortis eget.
                </AccordionDetails>
            </Accordion>


        </div>
    )
}

export default MarketplacePlanBenefits